import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { NEVER, Observable, of as observableOf } from 'rxjs';

import { State } from '®app/ngrx';
import {
  BibliographicResource,
  OnlineResource,
  OnlineResourceUrlType,
} from '®shared/bibliographic-resource';
import { ExternalLinkClickEvent } from '®shared/list-item/events';
import { EditableItem } from '®shared/reading-list/models/editable-item';

import {
  BookstoreAndAvailability,
  FetchBookstoreAvailabilitiesAction,
  selectBookstoresAndAvailabilitiesForResourceId,
} from './bookstore';
import {
  FetchLibraryAvailabilityUnlessCachedAction,
  LoadableLibraryAvailability,
  selectLibraryAvailabilityForResourceId,
} from './library';

@Component({
  selector: 'rl-resource-availability',
  templateUrl: './resource-availability.component.html',
})
export class ResourceAvailabilityComponent implements OnInit {
  @Input() depth = 0;
  @Input() resource: BibliographicResource;
  @Input() overrideDefaultOnlineResource?: OnlineResource;
  @Input() item?: EditableItem;
  @Input() onlineResource?: OnlineResource;
  @Output() onlineResourceClick = new EventEmitter<ExternalLinkClickEvent>();

  libraryAvailability$?: Observable<LoadableLibraryAvailability> = NEVER;
  bookstoresAvailability$: Observable<BookstoreAndAvailability[]> =
    observableOf([]);

  digitisationLink?: string;

  constructor(private store: Store<State>) {}

  ngOnInit() {
    const { id: resourceId = undefined, isbns = undefined } =
      this.resource || {};

    if (resourceId) {
      this.libraryAvailability$ = this.store.select(
        selectLibraryAvailabilityForResourceId(resourceId),
      );
      this.store.dispatch(
        new FetchLibraryAvailabilityUnlessCachedAction({ resourceId }),
      );

      if (isbns && isbns.length > 0) {
        this.bookstoresAvailability$ = this.store.select(
          selectBookstoresAndAvailabilitiesForResourceId(resourceId),
        );
        this.store.dispatch(
          new FetchBookstoreAvailabilitiesAction({ resourceId }),
        );
      }
    }

    if (
      this.overrideDefaultOnlineResource?.type ===
      OnlineResourceUrlType.DIGITISATION
    ) {
      this.digitisationLink = this.overrideDefaultOnlineResource.external_url;
    }
  }
}
